// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_hu1","cls2":"SimplePaperPodcast-cls2_25O SimplePaperPodcast-cls1_hu1"};